import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class EnvService {
  CLIENTID = null;
  ACCOUNTID = null;
  NAV_LOGO = null;
  DISPLAYPAYWALL = null;
  PAYMENTAMOUNT = null;
  BANNER_LOGO = null;
  BANNER_HEADER_TEXT = null;
  BANNER_HEADER_TEXT_COLOR = null;
  BANNER_SUBHEADER_TEXT = null;
  BANNER_SUBHEADER_TEXT_COLOR = null;

  FIRSTNAME = null;
  LASTNAME = null;
  BIRTHDATE = null;
  MONTHDOB = null;
  DAYDOB = null;
  YEARDOB = null;
  PHONENUMBER = null;
  EMAILADDRESS = null;
  GENDER = null;
  ADDRESS1 = null;
  ADDRESS2 = null;
  CITY = null;
  STATE = null;
  ZIPCODE = null;
  PLANCODE = null;
  POLICYSTARTDATE = null;
  POLICYTERMDATE = null;
  PARENTRELATIONSHIP = 18;
  HASACCEPTEDTERMS =  1;
  UNIQUEUSERID = null;
  USERNAME = null;
  MISC1 = null;
  MISC2 = null;
  MISC3 = null;
  EXTERNALACCOUNTID = null;
  EXTERNALMEMBERID = null;
  EDITORID = 1;
  PASSWORD = null;
  PAYMENTSUCCESSFUL = null;

  TOKEN = null;
  INIT = false;
  CORE_API_URL = '';
  MEMD_PORTAL_URL = '';

  constructor() { }
}
